import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue';
import Cookies from "js-cookie";
import Constants from "@/utils/constants";
import {userInfo} from "@/utils/inputs";
Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: Layout,
    redirect: '/login',
    children: [{
        path: 'personal',
        name: 'Personal',
        component: () => import('@/views/personal/index'),
        meta: { title: '个人中心', icon: 'el-icon-user' }
    },{
        path: 'category',
        name: 'Category',
        component: () => import('@/views/category/index'),
        meta: { 
            title: '分类管理',
            icon: 'el-icon-document',
            roles: ['管理员']
        }
    },{
        path: 'title',
        name: 'Title',
        component: () => import('@/views/title/index'),
        meta: { 
            title: '标题管理',
            icon: 'el-icon-document',
            roles: ['管理员']
        }
    },{
        path: 'textbook',
        name: 'Textbook',
        component: () => import('@/views/textbook/index'),
        meta: { 
            title: '教材管理',
            icon: 'el-icon-s-custom',
            roles: ['管理员']
        }
    },{
        path: 'material',
        name: 'Material',
        component: () => import('@/views/material/index'),
        meta: { 
            title: '素材管理',
            icon: 'el-icon-s-order',
            roles: ['管理员']
        }
    },{
        path: 'article',
        name: 'Article',
        component: () => import('@/views/article/index'),
        meta: { 
            title: '文章管理',
            icon: 'el-icon-document',
            roles: ['管理员']
        }
    },{
        path: 'user/registry',
        name: 'UserRegistry',
        component: () => import('@/views/user/registry/index'),
        meta: { 
            title: '用户注册',
            icon: 'el-icon-user-solid',
            roles: ['管理员']
        }
    },
    {
        path: 'content',
        name: 'Content',
        component: () => import('@/views/content/index'),
        meta: { 
            title: '内容管理',
            icon: 'el-icon-document',
            roles: ['管理员']
        }
    },
    {
        path: 'contentGroup',
        name: 'ContentGroup',
        component: () => import('@/views/contentGroup/index'),
        meta: { 
            title: '内容分组',
            icon: 'el-icon-document',
            roles: ['管理员']
        }
    },
    {
        path: 'contentTag',
        name: 'ContentTag',
        component: () => import('@/views/contentTag/index'),
        meta: { 
            title: '内容标签',
            icon: 'el-icon-tag',
            roles: ['管理员']
        }
    },
    {
        path: 'rwTable',
        name: 'RwTable',
        component: () => import('@/views/rwTable/index'),
        meta: { 
            title: '读字表/写字表',
            icon: 'el-icon-s-order',
            roles: ['管理员']
        }
    }
    ]
}, {
    path: "/login",
    name: "Login",
    component: () => import('@/views/login/index'),
}]

// 修改Vue Router的push方法，避免重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    return Promise.resolve(false)
  })
}

// 同样修改replace方法
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    return Promise.resolve(false)
  })
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem(Constants.ID.USER_TOKEN_KEY);
    if(token == null && to.path != '/login'){
        return next('/login');
    }else {
        // 如果目标路径是登录页面，则不需要判断登录状态
        if (to.path == '/login') {
            next();
        } else{
            // 非登陆页跳转需要有效token
            userInfo().then(resp=>{
                if(resp == null){
                    next('/login');
                }else{
                    // 如果已经登录，继续执行路由
                    localStorage.setItem(Constants.ID.USER_KEY,JSON.stringify(resp));
                    next();
                }
            }).catch(e=>{
                return next('/login');
            })
        }
    }
});

export default router
